<template>
    <v-sheet
      :color="secondaryMenuColor"
      elevation="2"
    >
      <v-container>
        <v-layout row wrap justify-space-between>
          <v-layout row wrap justify-space-between>
            <v-sheet class="pt-10 pl-6" color="transparent" min-width="270">
              <v-img 
                min-height="137" 
                max-height="137"
                min-width="100"
                max-width="270"
                :src="companyLogo"
                contain
              ></v-img>
            </v-sheet>
          </v-layout>
          <v-layout row wrap justify-space-between>
            <v-col>
              <p class="font-weight-bold white--text pl-3" >Menu</p>
              <div v-for="item in menuItems" :key="item.id">
                <v-btn 
                  small 
                  rounded 
                  text 
                  class="white--text text-capitalize"
                  @click="clickMenuItem(item)"
                >
                  {{ item.name }}
                </v-btn>
              </div>
            </v-col>
          </v-layout>
          <v-layout row wrap justify-space-between>
            <v-col>
              <p class="font-weight-bold white--text pl-1" >Contato</p>
              <v-layout class="pl-3" row wrap justify-start align-start>
                <v-icon color="grey">place</v-icon>
                <v-sheet class="white--text caption" color="transparent" max-width="200">
                  {{ companyStreet }} {{ companyNumber }}, {{ companyDistrict }}, {{ companyCity }}/{{ companyState }}
                </v-sheet>
              </v-layout>
              <v-layout row wrap justify-start class="body-2 white--text pt-3 pl-4 pb-3">
                <v-img src="@/assets/icons/whatsapp.png" max-width="18" min-width="18" max-height="18" min-height="18"></v-img>
                <a target="_blank" rel="noopener noreferrer" :href="callWhatsAppApi" class="pl-2">{{ companyWhatsapp }}</a>
              </v-layout>
              <p class="body-2 white--text">
                <v-icon class="pr-1" color="grey">call</v-icon>
                {{ companyPhone }}
              </p>
              <p class="body-2 white--text">
                <v-icon class="pr-2" color="grey">mail</v-icon>
                <a :href="callSendEmail"> {{ companyEmail }} </a>
              </p>
            </v-col>
          </v-layout>
        </v-layout>
        <v-divider class="pb-1" dark></v-divider>
        <v-layout class="white--text" justify-center>
          <p class="pr-1">© 2020 All rights reserved by </p> 
          <a target="_blank" rel="noopener noreferrer" href="http://www.iliossistemas.com.br/" > Ilios Sistemas Ltda.</a>
        </v-layout>
      </v-container>
      <ContactUsForm v-if="loadContactUsForm" :open="openContactUsForm" @closeContactUsForm="openContactUsForm = false" />
      <RegisterImmobileForm v-if="loadRegisterImmobileForm" :open="openRegisterImmobileForm" @closeRegisterImmobileForm="openRegisterImmobileForm = false" />
    </v-sheet>
</template>

<script>

import { mapActions, mapGetters, mapState } from 'vuex'
import apiState from '@/ilios.store'
import ContactUsForm from '@/components/Global/ContactUsForm'
import RegisterImmobileForm from '@/components/Global/RegisterImmobileForm'

export default {
  name: 'BottomBar',

  components: {
    ContactUsForm,
    RegisterImmobileForm,
  },

  data: () => ({
    openContactUsForm: false,
    openRegisterImmobileForm: false,
    loadContactUsForm: false,
    loadRegisterImmobileForm: false,
    menuItems: [{id: 1, name: 'Início', url: '/inicio'},
                {id: 2, name: 'Negocie Seu imóvel', url: null},
                {id: 3, name: 'Financiamento', url: '/financiamento'},
                {id: 4, name: 'Fale Conosco', url: null},
                {id: 5, name: 'Quem Somos', url: '/quem_somos'}],
  }),

  mounted() {
    this.setCompanyDetails();
  },

  computed: {
    ...mapState('Company',{
      companyLogo: 'companyLogo',
      companyPhone: 'companyPhone',
      companyWhatsapp: 'companyWhatsApp',
      companyEmail: 'companyEmail',
      companyStreet: 'companyStreet',
      companyZip: 'companyZip',
      companyNumber: 'companyNumber',
      companyDistrict: 'companyDistrict',
      companyCity: 'companyCity',
      companyState: 'companyState',
      secondaryMenuColor: 'secondaryMenuColor',
    }),

    callWhatsAppApi(){
      return "https://api.whatsapp.com/send?phone=" + this.companyWhatsapp
    },

    callSendEmail() {
      return "mailto:" + this.companyEmail
    },

  },

  watch: {
  },

  methods: {
    ...mapActions({
      setCompanyDetails: "Company/setCompanyDetails",
    }),

    ...mapGetters({
      
    }),

    openContactUs(){
      this.loadContactUsForm = true
      this.openContactUsForm = true
    },

    openRegisterImmobile(){
      this.loadRegisterImmobileForm = true
      this.openRegisterImmobileForm = true
    },

    clickMenuItem(objMenu){
      switch (objMenu.id) {
        case 1:
          this.$router.push(objMenu.url).catch(err => { this.$router.go(0) })
          break;
        case 2:
          this.openRegisterImmobile()
          break;
        case 3:
          this.$router.push(objMenu.url).catch(err => { this.$router.go(0) })
          break;
        case 4:
          this.openContactUs()
          break;
        case 5:
          this.$router.push(objMenu.url).catch(err => { this.$router.go(0) })
          break;
      }
    }
  },
};
</script>